import { Component } from "@angular/core";

@Component({
	selector: "app-table",
	templateUrl: "./table.component.html",
	standalone: false,
})
export class TableComponent {}
